import React, {Component} from "react";
import {CSVLink} from "react-csv";
import MaterialIcon from "../MaterialIcon";
import Axios from "axios";
import getAxiosConfig from "../../utils/axiosConfig";
import {showToastForBackend} from "../../actions/toastActions";
import {connect} from "react-redux";
import {FormattedMessage} from 'react-intl';

class ExportCSV extends Component{
    constructor(props) {
        super(props);
        this.state = {
            CSVData : {
                data: []
            }
        };
        this.csvLink = React.createRef();
        this.getCSVData = this.getCSVData.bind(this);
    }

    getCSVData() {
        Axios.get(this.props.properties.chartUrl + "csv/" + this.props.chart.id, getAxiosConfig())
            .then(chartResponse => {
                this.setState({ CSVData: {data : chartResponse.data} }, () => {
                    this.csvLink.current.link.click();
                });
            })
            .catch(err => {
                if(err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    render() {
        return (
            <div>
                <button className="editor-button csv-button" onClick={() => this.getCSVData()}><MaterialIcon icon="save_alt" size={24}/><FormattedMessage id="Export CSV"/></button>
                <CSVLink
                    data={this.state.CSVData.data}
                    filename={this.props.chart.title + ".csv"}
                    className="hidden"
                    ref={this.csvLink}
                    separator={";"}
                />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        properties: state.properties
    }
}
export default connect(mapStateToProps, {showToastForBackend})(ExportCSV);